import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { IZA_CONFIG, IzaConfig } from './iza-config';

export function provideIza(config: IzaConfig): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: IZA_CONFIG, useValue: config }]);
}
